class DownloadUtil {
  static downloadFromBlob(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);

    // Trigger a click to start the download
    a.click();

    // Clean up the DOM element
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}

export default DownloadUtil;
